import type { ReactNode } from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { ThemeProvider } from 'styled-components'
import { AuthProvider } from '../../features/auth/AuthProvider'
import type { ConsultationPricing } from '../../features/pricing/pricingApi'
import { PricingProvider } from '../../features/pricing/PricingProvider'
import { GlobalStyle } from '../../styles/global'
import { theme } from '../../styles/theme'

type AppProvidersProps = {
  children: ReactNode
  initialPricing?: ConsultationPricing | null
}

/** Providers globais. O roteador fica por fora: BrowserRouter no navegador, StaticRouter no build. */
export function AppProviders({ children, initialPricing = null }: AppProvidersProps) {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <AuthProvider>
          <PricingProvider initialPricing={initialPricing}>{children}</PricingProvider>
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  )
}
